export const profileSyncAvatar = {
    templateUrl: Evisors.config.cdnRootWhitelabel + 'asset/partials/user/components/profileSyncAvatar.html',
    bindings: {
        title: '@',
        item: '<',
    },
};
